<!-- Main container for the connected galleries page -->
<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <!-- Page header -->
    <div class="cg-header">
      <div class="cg-header-left">
        <h1 class="cg-title">{{ 'connectedGalleries.yourConnectedGalleries' | transloco }}</h1>
        <p class="cg-subtitle">{{ 'connectedGalleries.subtitle' | transloco }}</p>
      </div>
      <div class="cg-header-actions">
        <p-dropdown [options]="statusFilterOptions" [filter]="true" [showClear]="true" inputId="statusFilter"
          name="statusFilter" [placeholder]="'connectedGalleries.filterByStatus' | transloco"
          styleClass="cg-filter" [(ngModel)]="filters.ConnectionStatus" (onChange)="onStatusFilterChange($event)">
        </p-dropdown>
        <button type="button" class="cg-btn cg-btn--ghost" (click)="openInviteExternalUserDialog($event)">
          <i class="fa fa-envelope"></i> {{ 'connectedGalleries.inviteByEmail' | transloco }}
        </button>
        <button type="button" class="cg-btn cg-btn--primary" (click)="openInviteDialog($event)">
          <i class="fa fa-plus"></i> {{ 'connectedGalleries.inviteAGallery' | transloco }}
        </button>
      </div>
    </div>

    <!-- Summary banner -->
    @if (summaryConnectedCount > 0) {
      <div class="cg-summary">
        <div class="cg-summary-lead">
          {{ 'connectedGalleries.summaryLead' | transloco:{ count: summaryConnectedCount } }}
        </div>
        <div class="cg-summary-stats">
          <div class="cg-stat">
            <span class="cg-stat-icon"><i class="fa fa-picture-o"></i></span>
            <span class="cg-stat-text"><span class="cg-stat-value">{{ summaryWorksPlaced }}</span>
              <span class="cg-stat-label">{{ 'connectedGalleries.worksPlaced' | transloco }}</span></span>
          </div>
          <div class="cg-stat">
            <span class="cg-stat-icon"><i class="fa fa-check"></i></span>
            <span class="cg-stat-text"><span class="cg-stat-value">{{ summarySold }}</span>
              <span class="cg-stat-label">{{ 'connectedGalleries.sold' | transloco }}</span></span>
          </div>
          <div class="cg-stat">
            <span class="cg-stat-icon"><i class="fa fa-line-chart"></i></span>
            <span class="cg-stat-text"><span class="cg-stat-value">{{ summaryEarned | currency:'USD':'symbol':'1.0-0' }}</span>
              <span class="cg-stat-label">{{ 'connectedGalleries.earned' | transloco }}</span></span>
          </div>
        </div>
      </div>
    }

    <!-- Gallery cards -->
    @if (connectedGalleries.length > 0) {
      <div class="cg-grid">
        @for (g of connectedGalleries; track g.Id) {
          <div class="cg-card" [class.cg-card--pending]="!g.IsInviteAccepted"
               (click)="onViewConsignmentsClicked(g)" role="button" tabindex="0">
            <div class="cg-card-head">
              <img class="cg-logo" [src]="g.GalleryImgUrl ? g.GalleryImgUrl : 'assets/images/No-Image.png'" [alt]="g.Name" />
              <div class="cg-card-headtext">
                <span class="cg-name">{{ g.Name }}</span>
                @switch (connectionState(g)) {
                  @case ('connected') { <span class="cg-badge cg-badge--success"><i class="fa fa-check-circle"></i> {{ 'connectedGalleries.connected' | transloco }}</span> }
                  @case ('sent') { <span class="cg-badge cg-badge--pending"><i class="fa fa-clock-o"></i> {{ 'connectedGalleries.waitingToAccept' | transloco }}</span> }
                  @case ('invited') { <span class="cg-badge cg-badge--pending"><i class="fa fa-envelope-o"></i> {{ 'connectedGalleries.invitedYou' | transloco }}</span> }
                }
              </div>
            </div>

            @if (g.IsInviteAccepted) {
              <div class="cg-contact">
                @if (galleryLocation(g)) { <div class="cg-contact-line"><i class="fa fa-map-marker"></i> {{ galleryLocation(g) }}</div> }
                @if (g.Email) { <div class="cg-contact-line"><i class="fa fa-envelope-o"></i> {{ g.Email }}</div> }
                @if (g.PhoneNumber) { <div class="cg-contact-line"><i class="fa fa-phone"></i> {{ g.PhoneNumber }}</div> }
              </div>
              <div class="cg-statline">
                <span><b>{{ availableCount(g) }}</b> {{ 'connectedGalleries.inInventory' | transloco }}</span>
                <span><b>{{ soldCount(g) }}</b> {{ 'connectedGalleries.sold' | transloco }}</span>
                <span><b>{{ earned(g) | currency:'USD':'symbol':'1.0-0' }}</b> {{ 'connectedGalleries.earned' | transloco }}</span>
              </div>
            } @else {
              <p class="cg-pendingtext">{{ g.IsInitiatedByArtist ? ('connectedGalleries.sentInviteText' | transloco) : ('connectedGalleries.invitedYouText' | transloco) }}</p>
              <div class="cg-pendingcta">{{ g.IsInitiatedByArtist ? ('connectedGalleries.viewProfile' | transloco) : ('connectedGalleries.respondToInvite' | transloco) }} <i class="fa fa-arrow-right"></i></div>
            }
          </div>
        }
      </div>
    } @else {
      <!-- Empty state -->
      <div class="cg-empty">
        <i class="fa fa-university"></i>
        <p>{{ 'connectedGalleries.emptyText' | transloco }}</p>
        <button type="button" class="cg-btn cg-btn--primary" (click)="openInviteDialog($event)">
          <i class="fa fa-plus"></i> {{ 'connectedGalleries.inviteAGallery' | transloco }}
        </button>
      </div>
    }
    </div>
  </div>


  <!-- Terms acceptance dialog -->
  @if (showTermsDialog && selectedGalleryForTerms) {
    <terms-acceptance-dialog [showDialog]="showTermsDialog" [galleryId]="selectedGalleryForTerms"
      (showDialogChange)="onTermsDialogClose()" (onAccepted)="onTermsDialogAccepted()"
      (onCancelled)="onTermsDialogCancelled()">
    </terms-acceptance-dialog>
  }

  <!-- Dialog for inviting external gallery -->
  <p-dialog [header]="'connectedGalleries.inviteGallery' | transloco" [(visible)]="inviteExternalUserDialogVisible" [modal]="true"
    [style]="{ 'width': '480px' }" [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
    (onHide)="closeInviteExternalUserDialog($event)">
    <!-- Logo section -->
    <div class="d-flex flex-column justify-content-center align-items-center p-4 mb-4">
      <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 250px;"
        [alt]="'connectedGalleries.logo' | transloco" />
      </div>

      <!-- Form for inviting external gallery -->
      <form class="form-horizontal px-3">
        <div class="form-group">
          <!-- Gallery name input -->
          <div class="mb-3">
            <label for="fullName" class="form-label fw-semibold mb-2">
              <span class="text-danger me-1">*</span>{{ 'connectedGalleries.galleryName' | transloco }}
            </label>
            <input type="text" id="fullName" [(ngModel)]="inviteExternalUserData.Name" pInputText [placeholder]="'connectedGalleries.galleryName' | transloco"
              class="form-control" name="fullName" required />
            </div>
            <!-- Gallery email input -->
            <div class="mb-4">
              <label for="email" class="form-label fw-semibold mb-2">
                <span class="text-danger me-1">*</span>{{ 'connectedGalleries.galleryEmail' | transloco }}
              </label>
              <input type="email" id="email" [(ngModel)]="inviteExternalUserData.Email" pInputText [placeholder]="'connectedGalleries.galleryEmail' | transloco"
                class="form-control" name="email" required />
              </div>
              <!-- Comment section -->
              <div>
                <label class="form-label fw-semibold mb-2">{{ 'connectedGalleries.comment' | transloco }}</label>
                <div class="position-relative">
                  <textarea id="comments" pInputTextarea rows="3" name="comments"
                    [(ngModel)]="inviteExternalUserData.InviteExternalComment" [placeholder]="'connectedGalleries.addCommentHere' | transloco"
                    class="form-control w-100">
                  </textarea>
                  <!-- Emoji picker button -->
                  <div class="emoji-icon position-absolute cursor-pointer fs-5" (click)="openEmojiDialog('external')"
                    style="top: 45%; right: 0.5rem; transform: translateY(-50%);">
                    😍
                  </div>
                </div>
                <!-- Send invitation button -->
                <div class="dialog-footer mt-4">
                  <button pButton type="button" (click)="inviteExternalUser()" [label]="'connectedGalleries.sendInvitation' | transloco"
                    class="w-100 p-button-outlined" [disabled]="!inviteExternalUserData.Email || !inviteExternalUserData.Name">
                  </button>
                </div>
              </div>
            </div>
          </form>
        </p-dialog>

        <!-- Dialog for inviting internal gallery -->
        <p-dialog [header]="'connectedGalleries.galleryInvitationManagement' | transloco" [(visible)]="inviteDialogVisible" [modal]="true"
          [style]="{ 'width': '500px' }" [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
          <!-- Logo section -->
          <div class="d-flex flex-column justify-content-center align-items-center p-4 mb-4">
            <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 250px;"
              [alt]="'connectedGalleries.logo' | transloco" />
            </div>

            <!-- Form for selecting gallery -->
            <form class="form-horizontal px-3">
              <div class="form-group">
                <!-- Gallery selection dropdown -->
                <div class="mb-4">
                  <label class="form-label fw-semibold mb-2">
                    <span class="text-danger">*</span> {{ 'connectedGalleries.selectGallery' | transloco }}
                  </label>
                  <p-dropdown [options]="availbleGalleries" [(ngModel)]="galleryId" name="inviteGallery"
                    (onChange)="onGallerySelection($event)" appendTo="body" [filter]="true" [filterBy]="'label'"
                    [optionLabel]="'label'" [optionValue]="'value'" [filterMatchMode]="'contains'"
                    [placeholder]="'connectedGalleries.selectGalleryToInvite' | transloco" class="w-100" [showClear]="true" filterPlaceholder="Type to search...">
                  </p-dropdown>
                  <!-- Info alert -->
                  <div class="alert alert-light border mt-3 p-3 small">
                    <i class="pi pi-info-circle text-primary me-2"></i>
                    {{ 'connectedGalleries.invitationInfo' | transloco }}
                  </div>
                </div>
                <!-- Comment section (visible when gallery is selected) -->
                @if (galleryId) {
                  <div class="mt-4">
                    <label class="form-label fw-semibold mb-2">{{ 'connectedGalleries.comment' | transloco }}</label>
                    <div class="position-relative">
                      <textarea id="comments" pInputTextarea rows="3" name="comments" [(ngModel)]="formData.InviteGalleryComment"
                        [placeholder]="'connectedGalleries.addCommentHere' | transloco" class="form-control w-100">
                      </textarea>
                      <!-- Emoji picker button -->
                      <div class="emoji-icon position-absolute cursor-pointer fs-5" (click)="openEmojiDialog('internal')"
                        style="top: 60%; right: 0.5rem; transform: translateY(-50%);">
                        😍
                      </div>
                    </div>
                    <!-- Send invitation button -->
                    <div class="dialog-footer mt-4">
                      <button pButton type="button" (click)="sendInvitation()" [label]="'connectedGalleries.sendInvitation' | transloco"
                        class="w-100 p-button-outlined" [disabled]="!galleryId">
                      </button>
                    </div>
                  </div>
                }
              </div>
            </form>
          </p-dialog>

          <!-- Stripe payment plan dialog -->
          @if (isStripeDisplayPlansDialogVisible) {
            <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
              [stripeAllPlans]="stripePlans" (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)">
            </stripe-payment-plan>
          }

          <!-- Notes dialog -->
          @if (notesDialogVisible) {
            <notes-dialog [connectGallery]="selectedGallery" [notesDialogVisible]="notesDialogVisible"
              (onCloseDialog)="closeNotesDialog($event)">
            </notes-dialog>
          }

          <!-- Emoji picker dialog -->
          @if (displayEmojiDialog) {
            <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
              (emojiClick)="addEmoji($event)">
            </app-emoji-list>
          }

          <!-- Settings dialog -->
          @if (settingDialogVisible && selectedGallery && selectedGallerySettings) {
            <p-dialog [header]="'connectedGalleries.gallerySettingsHeader' | transloco: { name: selectedGallery.Name }" [(visible)]="settingDialogVisible" [modal]="true"
              [style]="{'width': '430px'}" (onHide)="closeSettingDialog()">
              <form class="form-horizontal mt-2 px-3">
                <!-- Notes input -->
                <div class="form-group mt-2 position-relative">
                  <label for="galleryNotes">{{ 'connectedGalleries.notes' | transloco }}</label>
                  <textarea id="galleryNotes" pInputTextarea rows="5" name="galleryNotes"
                    [(ngModel)]="selectedGallerySettings.GalleryNotes" [placeholder]="'connectedGalleries.addNotesAbout' | transloco: { name: selectedGallery.Name }"
                    class="form-control">
                  </textarea>
                  <div class="emoji-icon position-absolute cursor-pointer fs-6" (click)="openEmojiDialog('galleryNotes')"
                    style="top: 75%; right: 0.5rem; transform: translateY(-50%);">
                    (😍)
                  </div>
                  <div class="small fst-italic text-muted mt-2">
                    <i class="fa fa-info-circle me-1"></i> {{ 'connectedGalleries.fieldPrivate' | transloco }}
                  </div>
                </div>
                <!-- Inventory access checkbox -->
                <div class="form-group mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="allowAvailableInventory" name="allowAvailableInventory"
                      [(ngModel)]="selectedGallerySettings.AllowAvailableInventory" />
                      <label class="form-check-label" for="allowAvailableInventory">
                        {{ 'connectedGalleries.allowInventoryAccess' | transloco }}
                      </label>
                    </div>
                  </div>
                  <!-- Save settings button -->
                  <div class="dialog-footer mt-4">
                    <button pButton type="button" (click)="saveSettings()" [label]="'connectedGalleries.saveSettings' | transloco" class="w-100 p-button-outlined">
                    </button>
                  </div>
                </form>
              </p-dialog>
            }

            <!-- Upgrade account dialog -->
            <p-dialog [(visible)]="displayUpgreadAccountDialog" [header]="'connectedGalleries.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
              [style]="{width: '450px'}">
              <div class="dialog-content">
                <!-- Warning section -->
                <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
                  <div class="d-flex align-items-center">
                    <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
                    <div>
                      <strong>{{ 'connectedGalleries.connectionLimitReached' | transloco }}</strong>
                      <p class="mb-2">
                        {{ 'connectedGalleries.connectionLimitText' | transloco }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Main content -->
                <p class="lead p-2">
                  {{ 'connectedGalleries.upgradeLeadText' | transloco }}
                </p>

                <!-- Upgrade call-to-action -->
                <div class="text-center mt-4">
                  <a href="javascript:void(0);" (click)="onUpgradeAccount()">
                    <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'connectedGalleries.upgradePlan' | transloco"
                      class="rounded shadow-lg img-fluid" />
                    </a>
                  </div>
                </div>
              </p-dialog>